import React from 'react'
import { clearDocumentType, getDocumentType, putDocumentType } from "../../../../actions";
import { DOCUMENT_TYPE_PATH } from "../../../../config/paths";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import Content from "../../../layout/Content";
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes, matchPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { useLayoutEffect } from 'react';
import DocumentTypeForm from './DocumentTypeForm';
import Immutable from 'immutable';
import { connect } from 'react-redux';

const EditDocumentType = ({
    breadcrumbs,
    dispatchGetDocumentType,
    dispatchClearDocumentType,
    dispatchPutDocumentType,
    match: {
        params: { id: documentTypeId },
    },
    loading,
    endpoint,
}) => {
    useLayoutEffect(() => {
        dispatchGetDocumentType({ documentTypeId });

        return () => dispatchClearDocumentType();
    }, []);

    const onSubmit = (formValues) => {
        const newFormValues = { ...formValues };

        dispatchPutDocumentType(documentTypeId, newFormValues);
    };

    const generateInitialValues = ({
        name,
        description
    }) => {
        return {
            name, 
            description
        };
    };

    let content;

    if (loading) content = <Loader />;
    else if (endpoint.isEmpty())
        content = <NoDataResource returnPage={DOCUMENT_TYPE_PATH} />;
    else
        content = (
            <DocumentTypeForm
                onSubmit={onSubmit}
                initialValues={generateInitialValues(endpoint.toJS())}
            />
        );

    return (
        <Content
            breadcrumbs={breadcrumbs}
            title="Editar Tipo de Documento"
            subtitle="Editar tipo de documento"
            content={content}
        />
    );
};

EditDocumentType.propTypes = {
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    dispatchClearDocumentType: PropTypes.func.isRequired,
    dispatchGetDocumentType: PropTypes.func.isRequired,
    dispatchPutDocumentType: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    match: matchPropTypes.isRequired,
    endpoint: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditDocumentType.defaultProps = {
    loading: false,
};

const mapDispatchToProps = {
    dispatchClearDocumentType: clearDocumentType,
    dispatchGetDocumentType: getDocumentType,
    dispatchPutDocumentType: putDocumentType,
};

const mapStateToProps = (
    { BusUnit },
    {
        match: {
            params: { id },
        },
    },
) => ({
    breadcrumbs: [
        ...BusUnit.UnitHome.get('breadcrumbs'),
        {
            text: 'Tipos de Documento',
            href: DOCUMENT_TYPE_PATH,
        },
        {
            text: 'Ver',
            href: `${DOCUMENT_TYPE_PATH}/${id}`,
        },
        {
            text: 'Editar',
            href: '',
        },
    ],
    endpoint: BusUnit.DocumentType.getIn(['current', 'content']),
    loading: !BusUnit.DocumentType.getIn([
        'current',
        'activity',
    ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDocumentType);
